import Vue from 'vue'
import VueI18n from '@klook/vue-i18n'
Vue.use(VueI18n)
import { admin_language_codes, merchant_language_codes } from '../../admin-cli.config.js'
import { convertApiLang } from '@klook/admin-utils'
import { replaceLocalesMap } from './utils'
import { messages as ui_message } from '@klook/admin-ui/lib/i18n'
export async function registerI18n(ctx) {
  let antLocale = {}
  const { isMerchant } = ctx
  const languageCodeList = isMerchant ? merchant_language_codes : admin_language_codes

  // merchant
  function getLocale() {
    const pathname = location.pathname
    let pathArr = pathname.split('/')
    let lang = pathArr[1]
    const language = (navigator.language || navigator.browserLanguage).toLowerCase()
    lang = lang || language
    const languageList = languageCodeList.map((i) => i.value)
    if (lang && languageList.includes(lang)) {
      return lang
    }
    return 'en'
  }

  // admin
  function getLanguage() {
    const chooseLanguage = window.localStorage.getItem('language')
    const language = (navigator.language || navigator.browserLanguage).toLowerCase()
    const lang = chooseLanguage || language
    const languageList = languageCodeList.map((i) => i.value)
    if (lang && languageList.includes(lang)) {
      return lang
    }
    return 'en'
  }

  // default admin UI languages, modify as needed
  // https://github.com/webpack/webpack/issues/4772
  let module_locales = require.context('../modules', true, process.env.DEFINE_I18N_REGEXP)

  // 站点多语言与ant多语言文件名称映射
  let antLocaleMapping = {
    en: 'en_US',
    'zh-CN': 'zh_CN',
    'zh-TW': 'zh_TW'
  }

  if (isMerchant) {
    Object.assign(antLocaleMapping, {
      ja: 'ja_JP',
      ko: 'ko_KR',
      th: 'th_TH'
    })
  }

  function loadLocaleMessages() {
    const messages = {}
    languageCodeList.forEach(({ value: lang }) => {
      messages[lang] = {
        ...module_locales
          .keys()
          .filter((v) => v.match(convertApiLang(lang)))
          .reduce(
            (acc, cur) => ({
              ...acc,
              ...module_locales(cur)
            }),
            {}
          ),
        ...ui_message[lang]
      }
    })
    return messages
  }

  const locale = isMerchant ? getLocale() : getLanguage()
  window.localStorage.setItem('language', locale)

  let antLang = antLocaleMapping[locale]
  const antList = require.context('ant-design-vue/lib/locale-provider', true, /\.js/)
  const antKey = antList.keys().find((v) => v.match(antLang))
  if (antKey) {
    antLocale = antList(antKey)
    antLocale = antLocale.default || antLocale
  }
  ctx.antLocale = antLocale || {}

  const messages = loadLocaleMessages()

  const old_t_fn = Vue.prototype.$t
  Vue.prototype.$t = function(...args) {
    return replaceLocalesMap(old_t_fn.apply(this, args))
  }

  // window.__ = function(key) {
  //   return replaceLocalesMap(_.get(messages[locale], key, key))
  // }

  const i18n = new VueI18n({
    locale, // set locale
    messages // set locale messages
  })
  let vm = new Vue({
    i18n
  })

  window.__ = vm.$t.bind(vm)

  i18n.admin_language_codes = languageCodeList
  ctx.i18n = i18n
}
